import React, {Component} from 'react';
import {Grid, Row, Col} from 'react-bootstrap'
import moment from 'moment-timezone'
import {Field} from 'redux-form'
import {renderDaySelector, renderHoursSelector, renderMinutesSelector, getDayWithOffsetFromToday} from './RenderFields'
import {formatInt} from './RenderFields'
import {timezone} from '../../constants'

class DateTime extends Component {

    constructor(props) {
        super(props)

        //console.log('Datetime constructor', 'props', props, 'props.val', props.val)

        if (props.val instanceof moment) {
            this.state = this.stateTimeComponents(props.val)
        } else {
            this.state = {day: getDayWithOffsetFromToday(0).key}
        }
    }

    stateTimeComponents = (m) => {
        //console.log('stateTimeComponents', m, typeof m, m instanceof moment)
        return {
            day: m.format('YYYY-MM-DD'),
            hours: m.hours(),
            minutes: m.minutes()
        }
    }

    notFalse = (x) => {
        return x || x === 0
    }

    componentWillUpdate(nextProps) {
        //console.log('Datetime componentWillUpdate', nextProps)

        const val = (nextProps.input || {}).value
        if ((val instanceof moment) && (!this.notFalse(this.state.hours) || !this.notFalse(this.state.minutes))) {
            this.setState(this.stateTimeComponents(val))
        }
    }

    timeChanged = (day, hours, minutes) => {

        const d = day || this.state.day
        const h = hours || this.state.hours
        const m = minutes || this.state.minutes

        this.setState({
            day: d,
            hours: h,
            minutes: m
        })

        console.log('DateTimeField', d,h,m, this.props)

        if (this.notFalse(d) && this.notFalse(h) && this.notFalse(m)) {
            const hoursMinsStr = `${formatInt(parseInt(h, 10))}:${formatInt(parseInt(m, 10))}`
            const str = `${d} ${hoursMinsStr}`
            const aMoment = moment.tz(str, timezone)
            console.log('update time moment', str, aMoment, this.props)

            this.props.input.onChange(aMoment)
        }
    }

    render() {

        //if (this.props.input.name === "firstEngineOn") {
        //    console.log('DateTime render', this.props.input.name, (this.props.input.value || {})._d, 'state', this.state)
        //}

        return (
            <div>
                {this.props.label && <label>{this.props.label}</label> }

                <div style={{width: '100%'}}>
                    <Grid fluid>
                        <Row>
                            <Col xs={6}>
                                <Field name={`${this.props.input.name}Day`} label='Date' wideDateRange={this.props.wideDateRange} component={renderDaySelector} onChange={(e) => this.timeChanged(e.target.value)}/>
                            </Col>
                            <Col xs={3}>
                                <Field name={`${this.props.input.name}Hours`} label="Time" component={renderHoursSelector} onChange={(e) => this.timeChanged(null, e.target.value)}/>
                            </Col>
                            <Col xs={3}>
                                <Field name={`${this.props.input.name}Minutes`} label={"\u00A0"} component={renderMinutesSelector} onChange={(e) => this.timeChanged(null, null, e.target.value)}/>
                            </Col>
                        </Row>
                    </Grid>
                </div>
            </div>
        );
    }
}

const DateTimeField = (props) => {
//stateless components can't have refs

    //console.log('DateTimeField render//', props)
    return <Field
        label={props.label}
        name={props.name}
        wideDateRange={props.wideDateRange}
        component={DateTime}
        val={props.val}
        onChange={event => {
            if (props.myOnChange) {
                props.myOnChange(event)
            }
        }}
    />
}

export default DateTimeField



// WEBPACK FOOTER //
// ./src/components/common/DateTimeField.jsx